import React, { Component } from 'react'
import { Header, Button, Columns } from 'components/elements'
import { AGE_QUESTION, AGE_QUESTION_ERROR } from '../main/constants.js'

class AgeQuestionScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      generalError: false,
      ageError: false
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(AGE_QUESTION)
  }

  setAgeError = () => {
    this.setState({
      ageError: true
    })
    this.props.onScreenLoad(AGE_QUESTION_ERROR)
  }

  render() {
    return (
      <React.Fragment>
        { !this.state.ageError && (
          <React.Fragment>
            <Header
              size={5}
              className="has-text-weight-extra-bold mt-6 has-text-centered"
            >
              Are you 25+ years old?
            </Header>
            <div
              style={{
                textAlign: 'center',
                marginTop: '4rem',
                marginBottom: '4rem',
              }}
            ></div>
            <Columns className="is-mobile">
              <Columns.Column size={6}>
                <Button
                  size="medium"
                  fullwidth
                  outlined
                  type="button"
                  onClick={() => this.props.onSuccess()}
                >
                  Yes
                </Button>
              </Columns.Column>
              <Columns.Column size={6}>
                <Button
                  size="medium"
                  fullwidth
                  outlined
                  type="button"
                  onClick={() => this.setAgeError()}
                >
                  No
                </Button>
              </Columns.Column>
            </Columns>
          </React.Fragment>
        )}
        { this.state.ageError && (
          <div className="has-text-centered">
            <Columns className="has-text-centered is-mobile is-centered">
              <Columns.Column size={10}>
                <Header size={5} className="has-text-weight-extra-bold">
                  Sorry.
                </Header>
                <i className="fad fa-baby fa-10x has-text-danger"></i>
                <p className="has-text-weight-extra-bold is-size-5 mb-0">
                  You must be 25 years or older to rent from this Twisted Road partner.
                </p>
                <p className="is-size-6 mb-6">
                  Return to our homepage and search for another bike.
                  If you need assistance, contact us at info@twistedroad.com.
                </p>
                <a className="button gold-button is-medium is-fullwidth has-text-weight-bold is-primary" href="/">
                  Got it. Search bikes.
                </a>
                <br />
              </Columns.Column>
            </Columns>
          </div>
        )}
      </React.Fragment>
    )
  }
}
export default AgeQuestionScreen

AgeQuestionScreen.defaultProps = {
  onSuccess: function() {},
  skippable: false,
  header: 'Age Question',
  onScreenLoad: function() {}
}
